import React, { useEffect, useState } from 'react';
import AdvancedAnalyticsDashboard from '../components/AdvancedAnalyticsDashboard';
import VendorPerformanceAnalytics from '../components/VendorPerformanceAnalytics';
import PlatformTrendsAnalysis from '../components/PlatformTrendsAnalysis';
import RevenueOptimizationDashboard from '../components/RevenueOptimizationDashboard';
import UserEngagementAnalytics from '../components/UserEngagementAnalytics';

export default function AnalyticsPage() {
  const [selectedDashboard, setSelectedDashboard] = useState<'overview' | 'vendor' | 'trends' | 'revenue' | 'engagement'>('overview');


  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#1a202c', paddingTop: '60px' }}>
      {/* Dashboard Selector */}
      <div style={{ 
        backgroundColor: '#2d3748', 
        borderBottom: '1px solid #4a5568',
        padding: '1rem 0',
        position: 'sticky',
        top: '60px',
        zIndex: 100
      }}>
        <div style={{ maxWidth: '1400px', margin: '0 auto', padding: '0 1.5rem' }}>
          <h1 style={{ fontSize: '1.875rem', fontWeight: 'bold', color: '#e2e8f0', marginBottom: '1rem' }}>
            Analytics Dashboard
          </h1>
          <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
            {[
              { key: 'overview', label: 'Platform Overview' },
              { key: 'vendor', label: 'Vendor Performance' },
              { key: 'trends', label: 'Market Trends' },
              { key: 'revenue', label: 'Revenue Optimization' },
              { key: 'engagement', label: 'User Engagement' }
            ].map(dashboard => (
              <button
                key={dashboard.key}
                onClick={() => setSelectedDashboard(dashboard.key as any)}
                style={{
                  padding: '0.5rem 1rem',
                  backgroundColor: selectedDashboard === dashboard.key ? '#3b82f6' : '#4a5568',
                  color: selectedDashboard === dashboard.key ? 'white' : '#e2e8f0',
                  border: '1px solid #4a5568',
                  borderRadius: '0.375rem',
                  fontSize: '0.875rem',
                  fontWeight: '500',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease'
                }}
                onMouseEnter={(e) => {
                  if (selectedDashboard !== dashboard.key) {
                    e.currentTarget.style.backgroundColor = '#2d3748';
                  }
                }}
                onMouseLeave={(e) => {
                  if (selectedDashboard !== dashboard.key) {
                    e.currentTarget.style.backgroundColor = '#4a5568';
                  }
                }}
              >
                {dashboard.label}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Dashboard Content */}
      <div style={{ minHeight: 'calc(100vh - 120px)' }}>
        {selectedDashboard === 'overview' && (
          <AdvancedAnalyticsDashboard userRole="admin" timeframe="30d" />
        )}
        
        {selectedDashboard === 'vendor' && (
          <VendorPerformanceAnalytics 
            vendorId="vendor-001" 
            timeframe="30d" 
            isOwnVendor={false} 
          />
        )}
        
        {selectedDashboard === 'trends' && (
          <PlatformTrendsAnalysis timeframe="90d" userRole="admin" />
        )}
        
        {selectedDashboard === 'revenue' && (
          <RevenueOptimizationDashboard userRole="admin" timeframe="90d" />
        )}
        
        {selectedDashboard === 'engagement' && (
          <UserEngagementAnalytics timeframe="30d" userRole="admin" />
        )}
      </div>
    </div>
  );
}